<template>
	<el-dialog v-bind="$attrs" v-on="$listeners" width="972px">
		<template #title>
			<h3 class="text-dark text-xl font-medium">出发日期 <span class="text-base text-secondary ml-2">{{stockState.count}}个日期可选</span></h3>
		</template>
		<div v-show="isLoading" class="h-100 relative flex items-center justify-center">
            <img class="w-20 h-[80px]" src="~@/assets/img/product/loading.gif" />
        </div>
		<el-table v-show="!isLoading"  class="product_table" :data="stockState.date" :height="stockState.date.length > 5 ? '450px':'none'">
		  <el-table-column label="出发日期"  align="center" #default="{ row }">
			<ul class="dates text-center text-base text-dark">
				<li class="date"><span>{{ row.date }}</span></li>
				<li class="date"><span>{{ row.week }}</span></li>
			</ul>
		  </el-table-column>
		  <el-table-column v-for="cabin in stockState.title" :key="cabin.key" :label="cabin.value"  #default="{ row }">
			<table-price-cell v-bind="row.data[cabin.key]" :isDistributor="isDistributor" />
		  </el-table-column>
		  <el-table-column label="预订" align="center" #default="{ row }"><el-button class="w-29" type="primary" @click="onBookingProduct(row)">预订</el-button></el-table-column>
		</el-table>
		<div class="flex items-center justify-center mt-4">
			<el-button type="primary" class="w-[180px]" @click="$emit('update:visible', false)">确定</el-button>
		</div>
	</el-dialog>
</template>
<script>
import {
	computed,
	defineComponent,
	useRouter,
	useStore,
	ref,
	useFetch
} from "@nuxtjs/composition-api";
import useMessage from "~/composables/useMessage";
import { submitCruiseTicketBooking } from "~/services/order";

import { getCruiseProductDate } from "~/services/product";
import useRequest from "~/composables/useRequest";
import useLoginDialog from '~/composables/useLoginDialog'
import TablePriceCell from '@/components/automation/table-price-cell.vue'
import { REQUEST_CODES } from "~/constants/const-http";

export default defineComponent({
	name: "ProductDetailDates",
	components: {
		TablePriceCell
	},
	props: {
		product_no: String
	},
	setup(props) {
		const store = useStore();
		const router = useRouter();
		const $message = useMessage();
		const { showLogin } = useLoginDialog();

		const { state: stockState, execute: fetchDates ,isLoading } = useRequest(
			getCruiseProductDate,
			{
				count: 0,
				type:0,
				date: [],
				title: []
			},
			{
				immediate: false
			}
		);

	
		useFetch(async () => {
      		await fetchDates(0, {
				product_no:props.product_no
			})
    	});


        // ======================= 产品预定 =======================
		async function onBookingProduct(stock) {
			if (!store.getters.loggedIn) {
				showLogin();
				return;
			}

			//单船预定
			if(stockState.value.is_tripartite_product){
				const { code, data, msg } = await submitCruiseTicketBooking({
					date: stock.date,
					product_no:props.product_no,
					supplier_id: stockState.value.supplier_id
				});
				if (code !== REQUEST_CODES.ERROR_OK) {
					$message.error(msg);
					return;
				}
	
				router.push({
					path: "placeorder",
					query: {
						booking_no: data.booking_no
					}
				});
			}else{
				router.push({
					path: "/product/cruise/pre-booking",
					query: {
						no: props.product_no,
					}
				});
			}
		}

		return {			
			stockState,
			onBookingProduct,
			isLoading
		};
	},

	computed: {
		isDistributor() {
			if (!this.$store.getters.loggedIn) {
				return false;
			}
			// if (!this.auth.loggedIn) return false;
			return !!this.$store.getters.userInfo.distributor;
		}
	}
});
</script>

<style lang="scss" scoped>
.title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}
::v-deep .product_table .el-table__header .el-table__cell {
  padding: 8px 0;
}
::v-deep .product_table:before {
  height: 0;
}
.date {
  padding-bottom: 0.5rem;
  position: relative;
}
.date:last-child::before {
  display: none;
}
.date:last-child {
  margin-bottom: 0px;
  padding-bottom: 0px;
}
</style>